import { Injectable } from '@angular/core';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';
import { IPais } from '../model/pais.model';

@Injectable()
export class PaisService extends EntityService<IPais> {
  constructor(protected configService: ConfigService) {
    super(
      {
        urlBackend: configService.backendURL,
        baseEntityEndPoint: 'pais',
        pluralBaseEntityEndPoint: 'paises'
      }
    );
  }
}
